const appName = process.env.VUE_APP_NAME;
/**
 * 简体中文
 */
export default {
  // 菜单路由
  route: {
    dashboard: {
      workplace: {_name: '首页'},
    },
    recharge: {
      _name: '充值',
    },
    settlement: {
      _name: '提现',
    },
    transaction: {
      _name: '列表页面',
      inorder: {_name: '代收'},
      outorder: {_name: '代付'},
      records: {_name: '账变'},
    },
    reconciliation: {
      bussiness: {_name: '统计'},
    },
    user: {
      _name: '个人中心',
      profile: {_name: '设置'},
      message: {_name: '我的消息'}
    },
  },
  // 主框架
  layout: {
    home: '首页',
    header: {
      profile: '个人中心',
      password: '修改密码',
      logout: '退出登录'
    },
    footer: {
      website: '官网',
      document: '文档',
      authorization: '授权',
      copyright: '无'
    },
    logout: {
      title: '提示',
      message: '确定要退出登录吗?'
    }
  },
  // 登录界面
  login: {
    title: appName,
    tip: '请输入账号和密码登录',
    username: '请输入',
    password: '请输入',
    captcha: '请输入',
    remember: '记住密码',
    forget: '忘记密码',
    login: '登录',
    loading: '登录中'
  },
  home: {
    accountOverview: '账户概览',
    realtimeFunds: '实时掌握您的资金动态',
    totalAmount: '总金额',
    availableBalance: '可用余额',
    frozenAmount: '冻结金额',
    unsettledBalance: '未结算余额'
  }
}
